import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";
import { GET_CASE_INDUCTION_TIME_QUERY_KEY } from "../types/CommonTypes";
import { GET_CASE_INDUCTION_TIME_RESPONSE } from "../types/ResponseTypes";

async function getCaseInductionTime(
  tenantId?: string,
  hospitalId?: string,
  queryString?: string
): Promise<GET_CASE_INDUCTION_TIME_RESPONSE> {
  const { data } = await fetcher({
    url: `analytics/induction-time?${queryString}`,
    headers: {
      "x-tenant-id": tenantId,
      "x-hospital-id": hospitalId,
    },
  });
  return data;
}

export default function useGetCaseInductionTimeQuery(
  tenantId?: string,
  hospitalId?: string,
  queryString: string = ""
) {
  return useQuery({
    queryKey: [GET_CASE_INDUCTION_TIME_QUERY_KEY, queryString, hospitalId],
    queryFn: () => getCaseInductionTime(tenantId, hospitalId, queryString),
    refetchInterval: 60000,
    enabled: !!tenantId && !!hospitalId,
  });
}
